<script setup>
</script>

<template>
  <section class="section">
    <div class="wrap" style="display:grid; gap: var(--sp-6); max-width: 860px;">
      <h1>Wat is Leela?</h1>

      <div>
        <h3>Eerst een kleine geschiedenis:</h3>
        <p>De oorspronkelijke betekenis van het woord Leela is: Speels. In het Engels "playful".</p>
        <p>
          Maar zoals vaker gebeurt met woorden krijgen ze ook andere betekenissen. In India werd het
          woord ook synoniem voor een spel. Een spel dat ontwikkeld werd door de Rishi's. En de
          Rishi's zijn de aloude meesters die de oude teksten schreven die de basis vormen van het
          hindoeïsme. Dus een spel dat tussen de 5000 en 7000 jaar oud is.
        </p>
        <p>Het spel staat ook bekend als "Het spel van het leven en zelfkennis".</p>
        <p>
          Rondom 1975 her-ontdekte schrijver en spirituele meester Harish Johari dit spel en schreef
          er een boek over. In 1978 was hij in Nederland op een retraite en kreeg toen de Nederlandse
          vertaling. Wars van alles en iedereen gaf hij het auteurskopie aan mijn zus, die daar was
          om te helpen met de schoonmaak (en, als ze tijd had, te luisteren naar hem en mee te
          mediteren.) Zij gaf het boek toen ik volwassen was op haar beurt aan mij.
        </p>
        <p>
          Hoewel ik Harish Johari maar kort had gezien als kind van 9, heeft hij wel indruk gemaakt op
          mij. Ik ging als volwassene mij verdiepen in het spel en de teksten. En dan doe ik nog steeds.
        </p>

        <h3>Allemaal "Gezelli met Kanelli" maar wat doet het en wat kan ik er mee en wat doe jij dan?</h3>
        <p>
          Tezamen spelen we het spel. Dat kan jij en ik zijn, maar ook jij met een kleine groep met
          mij als "Spel-begeleider".
        </p>
        <p>En daarmee krijg je:</p>
        <ul>
          <li>Meer inzicht over je levenspad en wat je obstakels zijn, maar ook wat je juist helpt.</li>
          <li>
            En doordat het "spel" door middel van de synchroniciteit van de dobbelsteen een gids kan
            zijn in, het ontdekken, je herinneren van je eigen wijs-heid geeft het inzichten die je
            misschien anders moeilijker had ontdekt of ontvangen.
          </li>
        </ul>
      </div>

      <aside class="soft-note">
        <p>
          <strong>Let op!</strong> Door het spelen van het spel Leela kan je (zelf) bewustzijn worden
          vergroot en verhoogt het de kans op persoonlijke transformatie met innerlijke vrede en
          vreugde ten gevolge.
        </p>
      </aside>

      <div class="page-tail">
        <p class="read-also">
          <span class="k">Lees ook:</span>
          <router-link to="/wat-is-reiki" class="jargon-link">Wat is Reiki?</router-link> ·
          <router-link to="/elementen-healing" class="jargon-link">Elementen Healing van Avelon</router-link>
        </p>
        <div class="actions">
          <router-link class="btn btn-primary" to="/contact-2">Vrijblijvend kennismaken</router-link>
          <router-link class="btn btn-ghost" to="/spirituele-coaching">Naar spirituele coaching</router-link>
        </div>
      </div>
    </div>
  </section>
</template>
